import { Fragment, useMemo, useRef, useState } from "react";
import type { ReactNode } from "react";
import { type SelectionBox, useSelectionContainer } from "@air/react-drag-to-select";
import { SelectionContext, intersectsBox } from "./selection-context";

interface SelectionProviderProps {
	children: ReactNode;
}

export function SelectionProvider({ children }: SelectionProviderProps) {
	const [selectedIds, setSelectedIds] = useState<Set<string>>(new Set());
	const elementRefs = useRef(new Map<string, HTMLElement>());
	const payloads = useRef(new Map<string, unknown>());

	const { cancelCurrentSelection, DragSelection } = useSelectionContainer({
		onSelectionChange: (box: SelectionBox) => {
			const next = new Set<string>();
			for (const [id, el] of elementRefs.current) {
				if (intersectsBox(box, el.getBoundingClientRect())) next.add(id);
			}
			setSelectedIds(next);
		},
	});

	const value = useMemo(
		() => ({
			selectedIds,
			setSelectedIds,
			elementRefs: elementRefs.current,
			payloads: payloads.current,
			cancelCurrentSelection,
		}),
		[selectedIds, cancelCurrentSelection],
	);

	return (
		<SelectionContext.Provider value={value}>
			<Fragment>
				{children}
				<DragSelection />
			</Fragment>
		</SelectionContext.Provider>
	);
}
